'use client';

import { ThemeProvider } from "@/components/ui/theme-provider";
import { Toaster } from '@/components/ui/sonner';

interface ProvidersProps {
  children: React.ReactNode;
}

export function Providers({ children }: ProvidersProps) {
  return (
    <ThemeProvider attribute="class" defaultTheme="dark">
      <div className="min-h-screen bg-background text-foreground">
        {children}
      </div>
      <Toaster
        position="bottom-right"
        closeButton
        richColors
        expand
        visibleToasts={6}
        toastOptions={{
          style: { fontSize: '0.875rem' },
        }}
      />
    </ThemeProvider>
  );
}
